





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import SmsMessages from './smsMessages.vue';
import { ProductsApi } from '../../../api';

@Component({
	components: { SmsMessages },
})
export default class SmsAlerts extends Vue {
	@Prop({ type: Number, required: true })
	public readonly productId!: number;
	@Prop({ type: Array, required: true })
	public readonly alerts!: any[];

	private api: ProductsApi = new ProductsApi();
	public loading: boolean = false;
	public selected: any;
	public deliveryLogs: any[] = [];
	public fields = [
		{ key: 'created_at', label: 'Date', sortable: true },
		{ key: 'num_sent_chargeable', label: 'Number Sent Chargeable', sortable: true },
		{ key: 'num_sent_failed', label: 'Num Sent Failed', sortable: true },
		{ key: 'num_sent_fault_status', label: 'Number Sent Fault Status', sortable: true },
		{ key: 'num_sent_success', label: 'Num Sent Success', sortable: true },
		{ key: 'ordway_order_id', label: 'Ordway Order ID', sortable: true },
		{ key: 'ordway_order_created_at', label: 'Charge Created Date', sortable: true },
		{ key: 'product_tier', label: 'Tier', sortable: true },
		{ key: 'status', label: 'Billing Status', sortable: true },
		{ key: 'id', label: 'View Sent SMS', sortable: true },
	];

	public async handleClick(alert: any) {
		this.$bvModal.show('sms-monthly-modal');
		this.loading = true;
		const data = await this.api.getSmsProductChargesDetail(this.productId, alert.item.id);
		this.deliveryLogs = data.data.data ?? [];
		this.loading = false;
	}
}
